import React from 'react'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Page/Contact'
import Footer from '../../component/Page/Footer'
import Portofolio from '../../component/Page/Portofolio'
import Memories from '../../component/Page/Memories'

const PortofolioDetail = () => {
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section className="position-relative pb-0">
                <div className="container">

                    <div className="text-center mb-5">
                        <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024 text-capitalize color__brown">
                            <img src="./../images/Vector 2.png" alt="" />
                            <span className="mx-3">march 4, 2023</span>
                            <img src="./../images/Vector 1.png" alt="" />
                        </div>
                        <h2 className="semi-bold font__size--64 text__65-1024 text__65-sm text__65-xxs play">Marcus & Erin</h2>
                        <p className='normal font__size--18 text__18-1024'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra <br /> a mi. Faucibus posuere sit nibh tristique tortor massa at non.</p>
                    </div>

                    <img src="./../images/sasas.png" className='w-100 mb-5' alt="" />

                    <div className="row justify-content-center">
                        <div className="order-md-1 order-2 col-md-5 col-lg-4 my-auto text-center text-md-left">
                            <img src="./../images/sv (3).png" className='images__porto-side' alt="" />
                        </div>
                        <div className="order-1 order-md-2 col-md-6 mb-4 my-md-auto">
                            <div className="d-flex align-items-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-2 mx-sm-3">client request</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="semi-bold font__size--24 text__24-1024 play mb-4">Our can help couples determine their wedding theme or concept and create suitable decoration and invitation designs.</h2>

                            <ul className='medium font__size--20 text__20-1024 play pl-4'>
                                <li className='mb-3'>Wedding date: <span className='color__brown'>March 4, 2023</span></li>
                                <li className='mb-3'>Budget: <span className='color__brown'>$ 2,999.00 USD</span></li>
                                <li className='mb-3'>Location: <span className='color__brown'>Milan, Italy</span></li>
                                <li className='mb-3'>Guest count: <span className='color__brown'>200 guest</span></li>
                                <li className='mb-3'>Theme and decoration: <span className='color__brown'>Elegant</span></li>
                                <li className='mb-3'>Additional services: <span className='color__brown'>Photography, Videography, Music</span></li>
                            </ul>
                        </div>
                    </div>

                </div>
            </section>


            <section>
                <div className="container">
                    <div className="d-flex align-items-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                        <img src="./../images/Vector 2.png" alt="" />
                        <span className="mx-3">Execution</span>
                        <img src="./../images/Vector 1.png" alt="" />
                    </div>
                    <h2 className="semi-bold font__size--32 text__32-1024 play mb-5">Making The Story</h2>

                    <div className="row">
                        <div className="col-lg-8 mb-4 mb-lg-0">
                            <div className="row">
                                <div className="col-md-4">
                                    <h4 className='semi-bold font__size--24 text__24-1024 play'>Photography</h4>
                                </div>
                                <div className="col-md-8">
                                    <p className='normal font__size--18 text__18-1024 color__gray-1'>Talan Rosser is the most professional photographer of the wedding. He will make your photos and moments last.</p>
                                </div>
                            </div>
                            <hr className='my-5 hr__footer' />
                            <div className="row">
                                <div className="col-md-4">
                                    <h4 className='semi-bold font__size--24 text__24-1024 play'>Decor</h4>
                                </div>
                                <div className="col-md-8">
                                    <p className='normal font__size--18 text__18-1024 color__gray-1'>Your wedding day is a dream come true, and we want to help make it a reality. Our team will go above and beyond to ensure you have the best day of your life.</p>
                                </div>
                            </div>
                            <hr className='my-5 hr__footer' />
                            <div className="row">
                                <div className="col-md-4">
                                    <h4 className='semi-bold font__size--24 text__24-1024 play'>Organization</h4>
                                </div>
                                <div className="col-md-8">
                                    <p className='normal font__size--18 text__18-1024 color__gray-1'>We know how special your wedding day is and we want to share in the planning of your special day. We offer packages that incorporate everything you need to make your day amazing.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center text-lg-right">
                            <img src="./../images/sv (2).png" alt="" />
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container">
                    <div className="d-flex align-items-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                        <img src="./../images/Vector 2.png" alt="" />
                        <span className="mx-3">Planning</span>
                        <img src="./../images/Vector 1.png" alt="" />
                    </div>
                    <h2 className="semi-bold font__size--32 text__32-1024 play mb-5">Our can assist couples in selecting the wedding location, <br className='d-none d-md-block' /> vendors, and planning a schedule that runs smoothly on <br className='d-none d-md-block' /> their wedding day.</h2>


                    <div className="row">
                        <div className="col-md-4">
                            <h4 className='semi-bold font__size--24 text__24-1024 play'>1. Consultation</h4>
                        </div>
                        <div className="col-md-8">
                            <p className='normal font__size--18 text__18-1024 color__gray-1'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst. </p>
                        </div>
                    </div>
                    <hr className='my-5 hr__footer' />
                    <div className="row">
                        <div className="col-md-4">
                            <h4 className='semi-bold font__size--24 text__24-1024 play'>2. Vendor Arrangements</h4>
                        </div>
                        <div className="col-md-8">
                            <p className='normal font__size--18 text__18-1024 color__gray-1'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst. </p>
                        </div>
                    </div>
                    <hr className='my-5 hr__footer' />
                    <div className="row">
                        <div className="col-md-4">
                            <h4 className='semi-bold font__size--24 text__24-1024 play'>3. Event Coordination</h4>
                        </div>
                        <div className="col-md-8">
                            <p className='normal font__size--18 text__18-1024 color__gray-1'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst. </p>
                        </div>
                    </div>
                    <hr className='my-5 hr__footer' />
                    <div className="row">
                        <div className="col-md-4">
                            <h4 className='semi-bold font__size--24 text__24-1024 play'>4. Beauty Services</h4>
                        </div>
                        <div className="col-md-8">
                            <p className='normal font__size--18 text__18-1024 color__gray-1'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst. </p>
                        </div>
                    </div>


                </div>
            </section>


            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mb-4 my-md-auto text-center text-md-left">
                            <h5 className='semi-bold font__size--32 text__32-1024 play'>Summary <br className='d-none d-md-block' /> Event</h5>
                        </div>
                        <div className="col-md mb-4 my-md-auto text-center">
                            <h5 className='semi-bold font__size--64 text__65-1024 text__65-sm text__65-xxs color__brown play'>Elegant</h5>
                            <p className='normal font__size--16'>Theme</p>
                        </div>
                        <div className="col-md mb-4 my-md-auto text-center">
                            <h5 className='semi-bold font__size--64 text__65-1024 text__65-sm text__65-xxs color__brown play'>180+</h5>
                            <p className='normal font__size--16'>total Guest </p>
                        </div>
                        <div className="col-md mb-4 my-md-auto text-center">
                            <h5 className='semi-bold font__size--64 text__65-1024 text__65-sm text__65-xxs color__brown play'>Milan</h5>
                            <p className='normal font__size--16'>Venue</p>
                        </div>
                    </div>
                </div>
            </section>

            <Memories />
            
            <Portofolio />

            <Contact />

            <Footer />
        </div >
    )
}

export default PortofolioDetail